import { UserOutlined } from '@ant-design/icons';
import { PageController } from '@client/components/_core/layout/PageController';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { errorMessage } from '@client/components/_ui/feedback/error-message/ErrorMessage';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { createFileRoute } from '@tanstack/react-router';
import { Card, Col, Row } from 'antd';
import { FileBarChart2 } from 'lucide-react';

export const Route = createFileRoute('/admin-console/monitoring/reports')({
    staticData: {
        permissions: ['admin_system:read'],
        breadcrumb: {
            title: 'Reports',
        },
        ui: {
            icon: FileBarChart2,
            title: 'Reports',
            widthVariant: 'default',
            menuDescription: 'Generate and view reports',
        },
    },
    component: Reports,
});

function Reports() {
    const spanConfig = {
        xs: 24,
        sm: 12,
        md: 8,
        lg: 6,
    };
    const { trpcClient } = useTrpc();

    const handleDownloadCSV = async () => {
        try {
            const activeUsers = await trpcClient.admin.report.activeUsers.query();
            const { parse } = await import('json2csv');

            const csv = parse(activeUsers, {
                fields: ['id', 'email', 'fullName', 'firstName', 'lastName'],
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);

            link.setAttribute('href', url);
            link.setAttribute('download', `active-users-${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            errorMessage.show(error);
        }
    };

    return (
        <PageController route={Route}>
            <Row gutter={[16, 16]}>
                {/* Users Statistics */}
                <Col {...spanConfig}>
                    <Card
                        title={
                            <div className="flex items-center gap-2">
                                <UserOutlined className="text-green-500" />
                                <span>Active users </span>
                            </div>
                        }
                    >
                        <div className="text-sm text-subtle-foreground">
                            Useful for email campaigns and user outreach
                        </div>
                        <div className="mt-4 flex justify-end">
                            <Button type="primary" size="small" onClick={handleDownloadCSV}>
                                Download CSV
                            </Button>
                        </div>
                    </Card>
                </Col>
            </Row>
        </PageController>
    );
}
